module.exports = __webpack_public_path__ + "media/hallBgm.39e57ae7.mp3";